import '../../../gettext'
import defaultConfig from '../../default'
import type { GatewayConfig } from '../../declarations'

import HeaderLogo from './HeaderLogo.svelte'
import MapIcon from 'images/icon-map.png'
import DatasetIcon from 'images/icon-dataset.png'
import GroupIcon from 'images/icon-group.png'
import ShowcaseIcon from 'images/icon-ribbon.png'
import GalleryIcon from 'images/icon-gallery.png'

export default {
  ...defaultConfig,

  gateway: 'nalcc',
  title: window.gettext('Northeast CPA'),
  logoComponent: HeaderLogo,
  footer: [
    { label: window.gettext('NORTHEAST'), href: 'https://www.northatlanticlcc.org/' },
    { label: window.gettext('ABOUT DATA BASIN'), href: '/about/' },
    { label: window.gettext('TERMS OF USE'), href: '/pages/terms-service/' },
    { label: window.gettext('CONTACT US'), href: '/services/contact/' },
  ],
  pages: {
    ...defaultConfig.pages,
    home: () => import('./Home.svelte'),
  },
  navigation: user => [
    {
      id: 'get-started',
      label: window.gettext('Get Started'),
      items: [
        {
          type: 'link',
          label: window.gettext('About the Northeast CPA'),
          href: '/pages/about-nalcc-CPA/',
        },
        ...(defaultConfig.navigation(user).find(menu => menu.id === 'get-started')?.items || []),
      ],
    },

    {
      id: 'explore',
      label: window.gettext('Browse'),
      items: [
        {
          type: 'heading',
          label: window.gettext('Categories'),
        },
        {
          type: 'link',
          label: window.gettext('Showcase'),
          image: ShowcaseIcon,
          href: '/showcase/',
        },
        {
          type: 'link',
          label: window.gettext('Galleries'),
          image: GalleryIcon,
          href: '/galleries/',
        },
        {
          type: 'link',
          label: window.gettext('Maps'),
          image: MapIcon,
          href: '/maps/',
        },
        {
          type: 'link',
          label: window.gettext('Datasets'),
          image: DatasetIcon,
          href: '/datasets/',
        },
        {
          type: 'link',
          label: window.gettext('Groups'),
          image: GroupIcon,
          href: '/groups/',
        },
        {
          type: 'divider',
        },
        {
          type: 'heading',
          label: window.gettext('Other CPAs'),
        },
        {
          type: 'link',
          label: window.gettext('2C1Forest Atlas'),
          href: 'https://2c1forest.databasin.org/',
        },
        {
          type: 'link',
          label: window.gettext('Gulf Coastal Plains and Ozarks LCC'),
          href: 'https://gcpolcc.databasin.org/',
        },
        {
          type: 'link',
          label: window.gettext('South Atlantic'),
          href: 'https://salcc.databasin.org/',
        },
        {
          type: 'link',
          label: window.gettext('Southeast Region'),
          href: 'https://seregion.databasin.org/',
        },
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: window.gettext('External Resources'),
          href: '/pages/nalcc-external-resources/',
        },
      ],
    },

    defaultConfig.navigation(user).find(menu => menu.id === 'create'),
  ],
} as GatewayConfig
